
const initialState = {
  acta: null,
  detalle: null,
  fileOk: false,
  fileDetallePdfOk: false,
  detalleLiqMercaderia: null
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'GENERAR_PDF':
      return {
        ...state,
        fileOk: action.fileOk
      }
    case 'GENERAR_DETALLE_PDF':
      return {
        ...state,
        fileDetallePdfOk: action.fileDetallePdfOk
      }
    case 'DETALLE_MERCADERIA':
      return {
        ...state,
        detalleLiqMercaderia: action.data
      }
    case 'INTERDICTO_CARTA_DE_PORTE':
      return {
        ...state,
        acta: action.acta
      }
    case 'RELEASE_INTERDICTO_CARTA_DE_PORTE':
      return {
        ...state,
        acta: null
      }
    default:
      return state
  }
}
